import { useCallback, useState } from "react";
import { startBioFlowHandoff } from "src/api/bioflow";
import {
  BioFlowHandoffCredentials,
  BIOFLOW_ONBOARDING_VERIFIED_KEY,
} from "src/types/bioflow";

export function useBioFlowHandoff() {
  const [isStarting, setIsStarting] = useState(false);

  const startHandoff = useCallback(
    async (
      targetWindow?: Window | null,
      credentials?: BioFlowHandoffCredentials,
    ) => {
      setIsStarting(true);
      try {
        const { redirectUrl } = await startBioFlowHandoff(
          credentials ? { password: credentials.password } : undefined,
        );
        if (targetWindow && !targetWindow.closed) {
          targetWindow.location.href = redirectUrl;
          targetWindow.opener = null;
        } else {
          window.location.href = redirectUrl;
        }
        return { success: true as const };
      } catch (error) {
        if (targetWindow && !targetWindow.closed) {
          targetWindow.close();
        }
        throw error;
      } finally {
        setIsStarting(false);
      }
    },
    [],
  );

  const markOnboardingVerified = useCallback(() => {
    sessionStorage.setItem(BIOFLOW_ONBOARDING_VERIFIED_KEY, "true");
  }, []);

  const isOnboardingVerified = useCallback(
    () => sessionStorage.getItem(BIOFLOW_ONBOARDING_VERIFIED_KEY) === "true",
    [],
  );

  const clearOnboardingVerified = useCallback(() => {
    sessionStorage.removeItem(BIOFLOW_ONBOARDING_VERIFIED_KEY);
  }, []);

  return {
    startHandoff,
    isStarting,
    markOnboardingVerified,
    isOnboardingVerified,
    clearOnboardingVerified,
  };
}
